import { render, staticRenderFns } from "./order-car-table.vue?vue&type=template&id=9b47750a&scoped=true&"
import script from "./order-car-table.vue?vue&type=script&lang=js&"
export * from "./order-car-table.vue?vue&type=script&lang=js&"
import style0 from "./order-car-table.vue?vue&type=style&index=0&id=9b47750a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b47750a",
  null
  
)

export default component.exports